module.exports = __webpack_public_path__ + "static/media/4_9.c3554eb9.png";